<template>
    <a href="#" :class="styles" @click.prevent="back">
        <slot>
            <i class="fa fa-chevron-circle-left m-r-5"></i> {{ $t('back') }}
        </slot>
    </a>
</template>

<script>
    export default {
        name: 'BackButton',
        props: {
            className: {
                type: String,
                default: () => 'btn btn-white'
            }
        },
        computed: {
            styles () {
                return this.className
            }
        },
        methods: {
            back () {
                this.$router.back()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/helpers/BackButton.vue